var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdlineSmart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 333.5 30.8",
    style: {
      enableBackground: "new 0 0 333.5 30.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.B\xF6jd_x0020_gr\xF6n{fill:url(#SVGID_1_);stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:1;}\r\n\t.st0{fill:#0055a0}\r\n\t.st1{fill:#e31818;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -18.4033,
    y1: 53.0325,
    x2: -17.6962,
    y2: 52.3254
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1DA238"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    style: {
      stopColor: "#24391D"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "202.7,30.4 194,30.4 194,0.2 202.7,0.2 202.7,30.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "147.8,30.4 139.3,30.4 139.3,0 147.8,0 147.8,30.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "125.6,30.4 117.4,30.4 117.4,0.3 125.6,0.3 125.6,30.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10.8,30.4 0,30.4 0,0.3 10.8,0.3 10.8,30.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,3.9c2,2.9,1.4,7.8-0.1,10.8c-1.9,3.7-6.5,3.6-10.4,3.5V0.3C17.2-0.1,21.4,0.4,23.4,3.9L23.4,3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.3,19l0.4,0.8c3.3,3.5,6.6,7.1,9.9,10.6h-11.8V8.7h9.9L206.3,19L206.3,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169,12.3c2.3,3.5,2.4,8.8,0.7,12.7c-1.2,3.2-4.9,5.2-8.6,5.4l-0.1-22.2C164.5,8.1,167.4,9.6,169,12.3 L169,12.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "191.9,18.5 182.6,8.7 191.9,8.7 191.9,18.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182,27.5c0.1,0.3,0.3,0.7,0.7,0.7c3.8,0.3,7.2-2.1,9-5.1c-0.1,1.7,0.8,4.2-1.4,4.9 c-3.1,2.2-7.9,3.3-11.7,1.7c-3.7-1.6-6.1-5.3-6.4-9.3c-0.3-4.1,1.1-8.1,4.4-10.3c1.6-0.7,3.3-1.3,5.2-1.3L182,27.5L182,27.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.3,30.4c-3.3-0.3-6.7-1.4-8.3-4.4c-2.3-3.7-2.2-9.3-0.1-12.9c1.6-3.1,4.8-4.8,8.3-4.7V30.4L159.3,30.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.5,11.1c1.7,2.1,2.2,5,2.2,8h-8V8.5C57.9,8.6,60.2,9.1,61.5,11.1L61.5,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7,27.8c0.7,0.8,2,0.5,3,0.4c3.1-0.5,5.2-3,6.8-5.2v3.3c-2.7,3.4-6.8,4.8-11.1,3.9c-4.2-0.9-7-4-7.8-8.3 c-0.8-4.9,0.9-9.4,4.6-12.2c1.3-0.8,2.9-1.1,4.6-1V27.8L53.7,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,9.5c0.8,0.9,1.2,2,1.2,3.3c0,1.3-0.6,2.2-1.4,3c-1.1,0.9-2.9,1.2-4.3,0.7c-1.3-0.6-2.4-1.9-2.6-3.4 c-0.3-1.6,0.5-3.1,1.7-3.9C38.6,8,41.3,8.2,42.6,9.5L42.6,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136,12.2c2.1,3.8,2.3,9.6,0.6,13.6c-1.3,3.2-4.9,4.7-8.5,4.5h-0.2V8.8C131,8.7,134.4,9.7,136,12.2L136,12.2z "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "84.4,30.4 76.1,30.4 76.1,8.8 84.4,8.8 84.4,30.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "74,30.4 65.5,30.4 65.5,8.8 74,8.8 74,30.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.4,11.8c0.7,1.6,0.6,3.4,0.6,5.3v13.4h-8.6V8.9C89.5,8.8,93.2,8.6,94.4,11.8L94.4,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.6,12.9c0.5,5.7,0.2,11.7,0.3,17.6h-8.4l-0.1-18.3c-0.2-1.2-0.8-1.9-1.7-2.7 C109.5,8.1,114.1,9.3,115.6,12.9L115.6,12.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.8,30.4 26.3,30.4 26.3,8.6 34.8,8.6 34.8,30.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.4,12.2c0.4,1.1,0.1,2-0.2,3c-0.7,1.4-2.3,2.4-4,2.4c-1.8-0.2-3.5-1.1-3.9-2.9c-0.4-1.6,0.1-3.4,1.3-4.5 c1.2-1.2,3.2-1.2,4.6-0.6C105.1,10.1,106,11.1,106.4,12.2L106.4,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.1,30.4c-3.3,0.1-6.9,0.2-8.5-2.7c-0.8-1.6-1.1-3.8-0.4-5.4c1.5-3.3,5.3-3.7,8.9-3.4V30.4L106.1,30.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.3,2.3c-0.2-0.1-0.5-0.1-0.8-0.1h-0.6v1.4h0.6c0.3,0,0.5,0,0.7-0.1c0.3-0.1,0.4-0.3,0.4-0.6 C210.6,2.6,210.5,2.4,210.3,2.3L210.3,2.3z M209.6,1.7c0.5,0,0.9,0,1.1,0.1c0.4,0.2,0.6,0.5,0.6,1c0,0.4-0.1,0.6-0.4,0.8 c-0.1,0.1-0.3,0.2-0.6,0.2c0.3,0,0.5,0.2,0.7,0.4c0.1,0.2,0.2,0.4,0.2,0.6v0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2l0,0h-0.6 c0,0,0,0,0,0c0,0,0,0,0,0l0-0.1V5.1c0-0.5-0.1-0.8-0.4-0.9c-0.1-0.1-0.4-0.1-0.8-0.1h-0.5v1.5h-0.7V1.7H209.6L209.6,1.7z  M207.4,1.5c-0.6,0.6-0.9,1.3-0.9,2.2c0,0.9,0.3,1.6,0.9,2.2c0.6,0.6,1.3,0.9,2.2,0.9c0.9,0,1.6-0.3,2.2-0.9 c0.6-0.6,0.9-1.3,0.9-2.2c0-0.9-0.3-1.6-0.9-2.2c-0.6-0.6-1.3-0.9-2.2-0.9C208.8,0.6,208,0.9,207.4,1.5L207.4,1.5z M212.2,6.2 c-0.7,0.7-1.5,1.1-2.5,1.1c-1,0-1.8-0.4-2.5-1.1c-0.7-0.7-1-1.5-1-2.5c0-1,0.4-1.8,1-2.5c0.7-0.7,1.5-1,2.5-1c1,0,1.8,0.3,2.5,1 c0.7,0.7,1,1.5,1,2.5C213.2,4.7,212.9,5.5,212.2,6.2L212.2,6.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.7,16.5c-0.6-2.5-2-3.1-3.7-3.1c-1.6,0-2.9,0.8-2.9,1.8s1.5,1.2,4.1,1.7c5.9,1.2,7.5,3.5,7.5,6.9 c0,4-3.6,6.9-8.8,6.9c-5,0-8.3-2.6-8.7-7.4l5.1-1.1c0.1,3.1,1.8,3.8,3.9,3.8c1.9,0,3.4-1,3.4-2.3c0-1.2-1.5-1.6-4.4-2.1 c-5.7-1.2-7.2-3.4-7.2-6.3c0-3.7,3.5-6.7,8.2-6.7c4.8,0,7.5,2.3,8.5,6.8L243.7,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277,30.5V18.3c0-3-1.5-4.8-4-4.8c-2.4,0-4,1.9-4,4.8v12.2h-5V18.3c0-3-1.5-4.8-3.9-4.8c-2.4,0-4,1.9-4,4.8 v12.2h-5V9.1h5v1.4c1.1-1.1,3.2-1.7,5.2-1.7c2.7,0,4.6,1.3,5.9,2.9c1.5-1.8,3.7-2.9,6.5-2.9c5.1,0,8.3,3.6,8.3,8.9v12.8H277z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.7,30.5c-0.5-0.6-0.8-1.5-0.9-2c-1.5,1.2-3.9,2.3-6.3,2.3c-4.3,0-7.2-2.4-7.2-6.2c0-3.5,2-7.2,12.9-9 c-0.3-1.5-1.8-2.2-3.6-2.2c-2.2,0-3.8,0.8-5.8,2.4l-2.9-3.4c2.9-2.5,5.8-3.6,9-3.6c3.8,0,8.4,1.5,8.4,7.6V25 c0,1.2,0.2,2.9,1.5,5.5H298.7z M297.3,20c-6.6,0.8-8,2.8-8,4.7c0,1.1,1.1,1.9,2.8,1.9c2.3,0,5.2-2,5.2-5.5V20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.8,20.3v10.2h-5V9.1h5v2.1c1.8-1.7,3.5-2.3,6.6-2.5v4.7C312.3,14,310.8,17.2,310.8,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.3,13.6v16.9h-5V13.6h-3.9V9.1h3.9V2.7h5v6.4h5.2v4.4H328.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdlineSmart);
export default __webpack_public_path__ + "static/media/prodline_smart.7f3281907a17c65853ec30dd2c63a445.svg";
export { ForwardRef as ReactComponent };